/* Progressive accessibility adapter. Revie owns review content, order and carousel clicks. */
if (!customElements.get('vv-revie')) {
  customElements.define('vv-revie', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.resize?.disconnect();
      this.abort = new AbortController();
      this.tracks = new WeakSet();
      this.links = new WeakSet();
      this.resize = new ResizeObserver(() => this.updateAll());
      this.resize.observe(this);
      this.observer = new MutationObserver(() => this.enhance());
      this.observer.observe(this, {childList: true, subtree: true});
      this.enhance();
    }
    enhance() {
      this.querySelectorAll('.rv3.rv3-f2').forEach((widget, index) => {
        const track = widget.querySelector('.carouselPre');
        if (!track) return;
        if (!this.tracks.has(track)) {
          this.tracks.add(track);
          track.id ||= this.closest('.shopify-section').id + '-revie-' + index;
          track.tabIndex = 0;
          track.setAttribute('role', 'list');
          track.setAttribute('aria-label', this.dataset.regionLabel);
          track.addEventListener('scroll', () => this.update(widget), {passive: true, signal: this.abort.signal});
          track.addEventListener('keydown', event => {
            if (event.target !== track) return;
            if (event.key !== 'Home' && event.key !== 'End') return;
            event.preventDefault();
            track.scrollTo({left: event.key === 'Home' ? 0 : track.scrollWidth, behavior: 'instant'});
          }, {signal: this.abort.signal});
        }
        const previous = widget.querySelector('.rv3-prev');
        const next = widget.querySelector('.rv3-next');
        for (const [button, label] of [[previous, this.dataset.previousLabel], [next, this.dataset.nextLabel]]) {
          if (!button) continue;
          button.setAttribute('aria-label', label);
          button.setAttribute('aria-controls', track.id);
        }
        track.querySelectorAll('.itemsC').forEach(item => {
          if (this.dataset.photoLabel) {
            const photo = item.querySelector('.bgImg');
            const author = item.querySelector('.contents p b')?.textContent.trim();
            if (photo?.style.backgroundImage && author) {
              photo.setAttribute('role', 'img');
              photo.setAttribute('aria-label', this.dataset.photoLabel + ' ' + author);
            }
          }
          const rating = item.querySelector('.rv-stars');
          if (rating) {
            const raw = rating.style.getPropertyValue('--rating').trim();
            const value = Number(raw);
            if (raw && Number.isFinite(value) && value >= 0 && value <= 5) {
              rating.setAttribute('role', 'img');
              rating.setAttribute('aria-label', value + ' ' + this.dataset.ratingLabel);
            }
          }
          const handle = item.dataset.go;
          const content = item.querySelector('.contents');
          if (!content || !handle || !/^[a-z0-9][a-z0-9-]*$/i.test(handle)) return;
          let link = content.querySelector('.vv-revie__product');
          if (!link) {
            link = document.createElement('a');
            link.className = 'vv-revie__product';
            content.append(link);
          }
          link.href = '/products/' + handle + '?utm_source=revie&utm_medium=revie_carousel&utm_campaign=revie';
          if (link.textContent !== this.dataset.productLabel) link.textContent = this.dataset.productLabel;
          if (!this.links.has(link)) {
            this.links.add(link);
            // Preserve normal anchor behavior (including opening in a new tab).
            link.addEventListener('click', event => event.stopPropagation(), {signal: this.abort.signal});
          }
        });
        if (!widget.querySelector('.vv-revie__count')) {
          const counter = document.createElement('span');
          counter.className = 'vv-revie__count';
          counter.setAttribute('aria-label', this.dataset.countLabel);
          widget.querySelector('.scrolly').append(counter);
        }
        this.update(widget);
      });
    }
    update(widget) {
      const track = widget.querySelector('.carouselPre');
      if (!track || !track.clientWidth) return;
      const items = [...track.querySelectorAll('.itemsC')];
      const bounds = track.getBoundingClientRect();
      const visible = items.flatMap((item, index) => {
        const box = item.getBoundingClientRect();
        const overlap = Math.min(box.right, bounds.right) - Math.max(box.left, bounds.left);
        return overlap >= box.width * .9 ? [index + 1] : [];
      });
      const counter = widget.querySelector('.vv-revie__count');
      const label = visible.length ? (visible[0] === visible.at(-1) ? visible[0] : visible[0] + '–' + visible.at(-1)) + ' / ' + items.length : '';
      if (counter && counter.textContent !== label) counter.textContent = label;
      const overflow = track.scrollWidth > track.clientWidth + 2;
      for (const button of widget.querySelectorAll('.rv3-btn')) {
        button.hidden = !overflow;
        button.disabled = button.classList.contains('rv3-prev') ? track.scrollLeft <= 2 : track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      }
      if (counter) counter.hidden = !items.length;
    }
    updateAll() { this.querySelectorAll('.rv3.rv3-f2').forEach(widget => this.update(widget)); }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.resize?.disconnect();
    }
  });
}
